// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2jJ9L","subheader":"ReorderModal_subheader__3krCL","listWrap":"ReorderModal_listWrap__3UsUj"};